import {DomElement,svgIcons,convert2d3d,getAlarmColor,getIcon} from '../../types/datatypes'


const iconlist=Object.keys(svgIcons)
class NumsElement extends DomElement{
  createValue(p){
        if(p.max!=0||p.min!=0){
          return p.min+' —— '+ p.max
        }else{
          return p.value
        }
    }
  createDom(){
    var container=super.createContainer()
    var color= getAlarmColor(this.params.alarm)

    var html=`
           <div class="content-container" style="border-color:`+color+`!important;">
            <div class="title" style="border-color:`+color+`">`+this.params.name+`</div>
            <div class="content">
              <span class="value" style="color:`+color+`">`+this.createValue(this.params)+`</span> <span class="unit">`+this.params.unit+`</span>
            </div>
          </div>
          <div class="icon-container box-shadow" style="background:`+color+`">
          `+getIcon(this.params.type)+`
          </div>
          <div  class="line" style="background:`+color+`"></div>
      `
    container.innerHTML=html
    return container
  }
  update(mesh,data){
    const createValue=(p)=>{
        if(p.max!=0||p.min!=0){
          return p.min+' —— '+ p.max
        }else{
          return p.value
        }
    }

    mesh.userData.params=Object.assign(mesh.userData.params,data)
    mesh.element.querySelector('.title').innerHTML=mesh.userData.params.name
    mesh.element.querySelector('.unit').innerHTML=mesh.userData.params.unit
    mesh.element.querySelector('.value').innerHTML=createValue(mesh.userData.params)
    var color=getAlarmColor(mesh.userData.params.alarm)
          mesh.element.querySelector('.title').style.borderColor=color
          mesh.element.querySelector('.content-container').style.borderColor=color
          mesh.element.querySelector('.value').style.color=color
          mesh.element.querySelector('.icon-container').style.background=color
          mesh.element.querySelector('.line').style.background=color
    if(mesh.userData.params.hasOwnProperty('state')&&mesh.userData.params.state==true){
     mesh.element.style.filter=''
    }else{
       mesh.element.style.filter='grayscale(100%)'
    }
  }
}

const dom= new NumsElement('nums','数字标签')
dom.format={
        name:{name:'标题',change(mesh,v){
          mesh.element.querySelector('.title').innerHTML=v
        }},
        unit:{name:'单位',change(mesh,v){
          mesh.element.querySelector('.unit').innerHTML=v
        }},
        alarm:{name:'告警级别',domtype:'number',min:0,max:3,change(mesh,v){
          var color=getAlarmColor(v)
          mesh.element.querySelector('.title').style.borderColor=color
          mesh.element.querySelector('.content-container').style.borderColor=color
          mesh.element.querySelector('.value').style.color=color
          mesh.element.querySelector('.icon-container').style.background=color
          mesh.element.querySelector('.line').style.background=color
        }},
        type:{name:'图标',domtype:'select',data:Object.keys(svgIcons),change(mesh,v){
          mesh.element.querySelector('.icon-container').innerHTML=getIcon(v)
        }},
        state:{name:'在线',domtype:'switch',data:Object.keys(svgIcons),change(mesh,v){
          if(v){
           mesh.element.style.filter=''
          }else{
             mesh.element.style.filter='grayscale(100%)'
          }
        }},
        use3d:{name:'3d对象',domtype:'switch',change(mesh,v){
           convert2d3d(mesh,v)
        }}
      }
dom.params={
      name:'',
      value:0,
      min:0,
      max:0,
      unit:'',
      alarm:0,
      type:'temp',
      state:true,//是否在线
      use3d:false,
      setting:['name','value','position']
    }
export default dom
